import { useEffect, useState } from "react";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getProfileVideoLinksService,
  insertProfileVideoLinksService,
} from "../../../../services/AthleteService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function AddProfileVideoLink({
  isOpen,
  setIsOpen,
  setProfileVideoLinks,
  setLoading,
  profileVideoLinks,
}) {
  const [data, setData] = useState({
    HudlFilmUrl: "",
    OneOnOnesVideoUrl: "",
    Track100mVideoUrl: "",
    BasketballHighlightsUrl: "",
    SevenOnSevenHighlightsUrl: "",
  });
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    // Map lowercase keys to PascalCase keys and default to empty strings
    const mappedData = {
      HudlFilmUrl: profileVideoLinks?.hudlFilmUrl || "",
      BasketballHighlightsUrl: profileVideoLinks?.basketballHighlightsUrl || "",
      Track100mVideoUrl: profileVideoLinks?.track100mVideoUrl || "",
      SevenOnSevenHighlightsUrl:
        profileVideoLinks?.sevenOnSevenHighlightsUrl || "",
      OneOnOnesVideoUrl: profileVideoLinks?.oneOnOnesVideoUrl || "",
    };

    setData(mappedData);
  }, [profileVideoLinks]);

  const handleChange = (e) => {
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClear = (fieldName) => {
    setData((prev) => ({ ...prev, [fieldName]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await insertProfileVideoLinksService(apiInstance, data);

      const updatedLinks = await getProfileVideoLinksService(apiInstance);
      setProfileVideoLinks(updatedLinks.data);
      toast.success("Video links added successfully!");
      setData({
        HudlFilmUrl: "",
        OneOnOnesVideoUrl: "",
        Track100mVideoUrl: "",
        BasketballHighlightsUrl: "",
        SevenOnSevenHighlightsUrl: "",
      });

      setIsOpen(false);
    } catch (error) {
      toast.error(
        "An error occurred while adding the video links. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-50"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity"
        />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-xl w-full space-y-4  bg-white rounded-lg">
            <div className="p-8">
              <DialogPanel className="max-w-2xl space-y-4  bg-white rounded-lg">
                <div className="p-0">
                  <DialogTitle className="text-xl uppercase pb-4">
                    New Video Links
                  </DialogTitle>
                  <form onSubmit={handleSubmit}>
                    {/* Hudl Film URL */}
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full px-3 mb-4">
                        <label
                          className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                          htmlFor="HudlFilmUrl"
                        >
                          Hudl Film URL
                        </label>
                        <div className="flex items-center">
                          <input
                            type="url"
                            name="HudlFilmUrl"
                            value={data.HudlFilmUrl}
                            onChange={handleChange}
                            placeholder="Enter Hudl Film URL"
                            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                          />
                          <button
                            type="button"
                            onClick={() => handleClear("HudlFilmUrl")}
                            className="ml-2 text-red-700 hover:text-red-500 p-2 pt-0"
                            aria-label="Clear Hudl Film URL"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Basketball Highlights URL */}
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full px-3 mb-4">
                        <label
                          className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                          htmlFor="BasketballHighlightsUrl"
                        >
                          Basketball Highlights URL
                        </label>
                        <div className="flex items-center">
                          <input
                            type="url"
                            name="BasketballHighlightsUrl"
                            value={data.BasketballHighlightsUrl}
                            onChange={handleChange}
                            placeholder="Enter Basketball Highlights URL"
                            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              handleClear("BasketballHighlightsUrl")
                            }
                            className="ml-2 text-red-700 hover:text-red-500 p-2 pt-0"
                            aria-label="Clear Basketball Highlights URL"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* 100 Meter Track Time Video URL */}
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full px-3 mb-4">
                        <label
                          className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                          htmlFor="Track100mVideoUrl"
                        >
                          100 Meter Track Time Video URL
                        </label>
                        <div className="flex items-center">
                          <input
                            type="url"
                            name="Track100mVideoUrl"
                            value={data.Track100mVideoUrl}
                            onChange={handleChange}
                            placeholder="Enter Track Time URL"
                            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                          />
                          <button
                            type="button"
                            onClick={() => handleClear("Track100mVideoUrl")}
                            className="ml-2 text-red-700 hover:text-red-500 p-2 pt-0"
                            aria-label="Clear Track 100m Video URL"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* 7 on 7 Highlights URL */}
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full px-3 mb-4">
                        <label
                          className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                          htmlFor="SevenOnSevenHighlightsUrl"
                        >
                          7 on 7 Highlights URL
                        </label>
                        <div className="flex items-center">
                          <input
                            type="url"
                            name="SevenOnSevenHighlightsUrl"
                            value={data.SevenOnSevenHighlightsUrl}
                            onChange={handleChange}
                            placeholder="Enter 7 on 7 Highlights URL"
                            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              handleClear("SevenOnSevenHighlightsUrl")
                            }
                            className="ml-2 text-red-700 hover:text-red-500 p-2 pt-0"
                            aria-label="Clear 7 on 7 Highlights URL"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* 1 on 1s Video URL */}
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full px-3 mb-4">
                        <label
                          className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                          htmlFor="OneOnOnesVideoUrl"
                        >
                          1 on 1s Video URL
                        </label>
                        <div className="flex items-center">
                          <input
                            type="url"
                            name="OneOnOnesVideoUrl"
                            value={data.OneOnOnesVideoUrl}
                            onChange={handleChange}
                            placeholder="Enter 1 on 1s Video URL"
                            className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                          />
                          <button
                            type="button"
                            onClick={() => handleClear("OneOnOnesVideoUrl")}
                            className="ml-2 text-red-700 hover:text-red-500 p-2 pt-0"
                            aria-label="Clear 1 on 1s Video URL"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="flex px-0 items-center justify-end ">
                      <button
                        type="button"
                        onClick={() => setIsOpen(false)}
                        className="text-gray-600 font-semibold hover:text-gray-800 mr-7"
                      >
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </DialogPanel>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </div>
  );
}
